import React from 'react';
import TranslateAddIcon from 'material-ui-icons/NoteAdd';
import {Link} from 'react-router-dom';
import {
    IconButton,
    Tooltip
} from 'material-ui';

const FaqTranslationsTableItemActionAdd = ({
    classes,
    faq,
    siteId,
    handleClick
}) => {
    return (
        <span className={classes.tableIconBtn}>
            <Link to={"/faqs/" + faq.id + "/translations/" + siteId}>
                <Tooltip title="Add Translation">
                    <IconButton className="smallIconButton editColor">
                        <TranslateAddIcon />
                    </IconButton>
                </Tooltip>
            </Link>{' '}
        </span>
    )
};

export default FaqTranslationsTableItemActionAdd;


// WEBPACK FOOTER //
// ./src/containers/faqs/translations/FaqTranslationsTableItemActionAdd.jsx